<script setup lang="ts">
import HeaderThemeChanger from './HeaderThemeChanger.vue';
import HeaderLogo from './HeaderLogo.vue';
import IconButton from '../../common/IconButton.vue';
import MenuPoints from '../../icons/MenuPoints.vue';
import Divider from '@/dashboard/vue/components/common/Divider.vue';
import { useHeader } from '@/dashboard/vue/components/layout/Header/useHeader';
import { isUserSignedIn } from '@/dashboard/utils/user/isUserSignedIn';
import HeaderMobile from '@/dashboard/vue/components/layout/Header/HeaderMobile.vue';
import { DOWNLOAD_APP_LINK } from '@/dashboard/constants/links';

const { baseWorkspaceLink, showThemeChanger, menuChanger, openThemeChangerBtn, currentPage, download } = useHeader();
</script>

<template>
  <div class="header-container fixed z-[1001] w-full bg-gray-100 px-m dark:bg-gray-975 max-tablet:px-s">
    <div v-if="false" id="banner" class="banner mx-[-40px] max-tablet:!hidden"></div>

    <header>
      <div class="flex items-center justify-between pb-[13px] pt-[17px] max-tablet:!hidden">
        <div class="flex items-center">
          <router-link v-if="isUserSignedIn()" :to="baseWorkspaceLink" class="fill-gray-900 dark:fill-gray-700">
            <HeaderLogo />
          </router-link>
          <a v-else href="/">
            <HeaderLogo />
          </a>

          <div class="relative ml-[10px]">
            <IconButton ref="openThemeChangerBtn" :active="showThemeChanger" :action="() => (showThemeChanger = true)" shadow>
              <MenuPoints />
            </IconButton>

            <HeaderThemeChanger v-if="showThemeChanger" ref="menuChanger" />
          </div>
        </div>

        <nav class="flex items-center gap-m">
          <a href="https://www.reddit.com/r/teampaper_me/" target="_blank" class="text-caption-s text-black dark:text-gray-500">Updates</a>
          <a :href="DOWNLOAD_APP_LINK" target="_blank" class="tppr-button s !rounded-40 !px-[18px]" @click="download">
            <span class="tppr-button__text">Download</span>
          </a>
        </nav>
      </div>

      <HeaderMobile />
      <div class="divider-panel h-[1px] max-tablet:hidden" />
    </header>
  </div>
</template>
